import { PEOPLE_SEARCH_CATEGORIES } from "./types.js";
/**
 * The only way a coverage count reaches a page.
 *
 * Exact and thousands-separated: never rounded, never "over N", never suffixed
 * with a "+". These are counts we hold the real number for, so an approximation
 * is both weaker than the truth and — once coverage moves — wrong.
 */
export function formatStatCount(count) {
    return count.toLocaleString("en-US");
}
/**
 * The people-search list: the coverage an entry-tier licence buys (consumer
 * Essentials, business Essentials Business).
 *
 * A derived count rather than a plan concept — the endpoint breaks the total
 * down by category and this is the two categories that make up that list. It
 * lives here because three surfaces need it (the plan benefits in hive, the
 * pricing table, the comparison matrix) and three additions of the same two
 * keys is three chances to add a third key to only two of them.
 *
 * It reads the slugs by name and adds no default for a missing one: a category
 * that is not there is not a zero, it is a payload we do not understand, and
 * `fetchPublicStats` refuses one rather than letting this publish 517 as 0.
 */
export function peopleSearchCount(stats) {
    return PEOPLE_SEARCH_CATEGORIES.reduce((total, slug) => total + stats.data_broker_types[slug], 0);
}
